
import { mapGetters } from "vuex";
export default {
	components: {
		breadcrumbs: () => import('../../components/pages/breadcrumbs.vue'),
		brandGrid: () => import('../../components/pages/brand-grid.vue')
	},
	computed: {
		...mapGetters({
			getterTranslates: 'getterTranslates',
			getterStoreLang : 'getterStoreLang'
		})
	}
}
